import { z } from 'zod'
import { oc } from '@orpc/contract'
import {
  BRIEFING_DISMISS_REASONS,
  BRIEFING_ITEM_KINDS,
  briefingItemStateSchema,
} from './briefing-day.contract'

// Longest reminder offered is next week at 8:00, so a day of slack on top of seven.
export const BRIEFING_REMIND_MAX_DAYS = 8

/**
 * Hide one briefing item for the caller (dismiss with a reason, or remind later) or bring it
 * back. Stored per provider and per item version; the item's source is never touched.
 */
export const briefingItemState = oc
  .route({ method: 'POST', path: '/v2/briefing/item-state' })
  .input(
    z
      .object({
        itemId: z.string().min(1).max(300),
        version: z.string().min(1).max(200),
        kind: z.enum(BRIEFING_ITEM_KINDS),
        patientId: z.string().min(1).max(64),
        sourceId: z.string().min(1).max(200),
        action: z.enum(['dismiss', 'remind', 'restore']),
        reason: z.enum(BRIEFING_DISMISS_REASONS).optional(),
        remindUntil: z.iso.datetime({ offset: true }).optional(),
        // A restore sent by the toast's Undo: put back the entry the action replaced.
        undo: z.boolean().optional(),
      })
      .refine((input) => input.action !== 'dismiss' || input.reason !== undefined, {
        message: 'A dismissal needs a reason',
        path: ['reason'],
      })
      .refine((input) => input.action !== 'remind' || input.remindUntil !== undefined, {
        message: 'A reminder needs remindUntil',
        path: ['remindUntil'],
      })
      .refine(
        (input) =>
          input.remindUntil === undefined ||
          (Date.parse(input.remindUntil) > Date.now() &&
            Date.parse(input.remindUntil) - Date.now() <=
              BRIEFING_REMIND_MAX_DAYS * 24 * 60 * 60 * 1000),
        {
          message: `remindUntil must be in the future and within ${BRIEFING_REMIND_MAX_DAYS} days`,
          path: ['remindUntil'],
        },
      ),
  )
  .output(z.object({ state: briefingItemStateSchema }))
